module.exports = __webpack_public_path__ + "assets/img/29_214_big.5d0aa964.jpg";